import { useState } from "react";
import type { FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ApiError } from "../api";
import { Ic, Logo } from "../components/ui";
import { useSession } from "../session";
import { useT } from "../i18n";

export default function Login() {
  const { user, loading, signIn } = useSession();
  const t = useT();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return null;
  if (user) {
    // Deep-linkul de dinainte de login, dacă a existat.
    const from = (location.state as { from?: string } | null)?.from;
    return <Navigate to={from ?? "/projects"} replace />;
  }

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      // Un mesaj unic pentru email greșit și parolă greșită: altfel formularul
      // devine un instrument de aflat ce adrese au cont.
      setError(t(err instanceof ApiError && err.code === "invalid_credentials"
        ? "login.credentiale" : "login.esec"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="split">
      <div className="pitch">
        <Logo size={26} />
        <div>
          <h1 className="disp">{t("login.pitch_titlu")}</h1>
          <p>{t("login.pitch_text")}</p>
        </div>
        <span className="lbl">{t("login.beta")}</span>
      </div>

      <div className="form-side">
        <form onSubmit={submit}>
          <h2 className="disp">{t("login.titlu")}</h2>

          <label className="field">
            <span className="lbl">{t("comun.email")}</span>
            <input type="email" autoComplete="username" value={email} required autoFocus
                   onChange={(e) => setEmail(e.target.value)} />
          </label>

          <label className="field">
            <span className="lbl">{t("comun.parola")}</span>
            <input type="password" autoComplete="current-password" value={password} required
                   onChange={(e) => setPassword(e.target.value)} />
          </label>

          {error && <p className="note bad" style={{ marginTop: 12 }}>{error}</p>}

          <div style={{ marginTop: 16 }}>
            <button className="btn btnp wide" type="submit" disabled={busy}>
              {t(busy ? "login.se_verifica" : "login.intra")}
            </button>
          </div>

          <div className="or">{t("login.sau")}</div>

          {/* Google OIDC vine într-un pas următor: consola Google refuză un
              redirect pe IP brut, deci are nevoie de domeniu sau de tunel. */}
          <button className="btn wide" type="button" disabled
                  title={t("login.google_titlu")}>
            <Ic n="google" s={15} />
            {t("login.google")}
          </button>

          <p className="note center" style={{ marginTop: 16 }}>
            {t("login.doar_invitatie")}
          </p>
        </form>
      </div>
    </div>
  );
}
